import { withChildren } from '@builder.io/react';
import React, { PropsWithChildren, ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';

export interface BuilderSectionProps extends React.HTMLAttributes<HTMLElement> {
    bgClassNames?: string;
    className?: string;
    heading?: string;
    headingClassOverrides?: string;
    subheading?: string;
}

const BuilderSection = ({
    bgClassNames = '',
    className = '',
    children = null,
    heading = '',
    headingClassOverrides = '',
    subheading = '',
    ...props
}: PropsWithChildren<BuilderSectionProps>): ReactElement => (
    <section className={`w-full ${bgClassNames}`} {...props}>
        <div
            className={`max-w-[1440px] px-6 py-16 md:px-12 md:py-24 lg:px-24 w-full mx-auto flex flex-col ${className}`}
        >
            {heading && (
                <h2
                    className={twMerge(
                        'block mb-6 text-center lg:text-left text-2xl lg:text-4xl',
                        'text-gray-900 font-bold font-polysans',
                        headingClassOverrides,
                    )}
                >
                    {heading}
                </h2>
            )}

            {subheading && (
                <div className="mb-6 text-base font-normal" dangerouslySetInnerHTML={{ __html: subheading }}></div>
            )}

            {children}
        </div>
    </section>
);
const sectionWithChildren = withChildren(BuilderSection);
sectionWithChildren.displayName = 'BuilderSection';
export default sectionWithChildren;
